function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuAccountOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.006 28.03c.024-1.55.074-6.276 1.402-7.605.874-.874 2.437-1.957 4.418-3.053a2.981 2.981 0 001.5-2.141 2.981 2.981 0 00-.774-2.523c-.985-1.046-1.538-1.785-1.538-4.702 0-1.846 1.045-4 3.998-4 2.953 0 4 2.154 4 4 0 2.905-.554 3.643-1.539 4.702a2.97 2.97 0 00-.775 2.523c.148.91.69 1.698 1.501 2.141 1.981 1.096 3.544 2.191 4.417 3.053 1.33 1.329 1.39 6.055 1.415 7.581H7.006v.025zm18-9.02c-1.328-1.318-3.518-2.647-4.86-3.385a.994.994 0 01-.233-1.551c1.39-1.477 2.08-2.732 2.08-6.068C21.992 5.003 19.986 2 15.987 2c-4 0-6.005 3.003-6.005 6.006 0 3.335.69 4.579 2.08 6.068a.994.994 0 01-.234 1.55c-1.341.74-3.531 2.068-4.86 3.385C5.32 20.683 5.049 24.474 5 28.006a1.988 1.988 0 001.993 2.006h18.014A1.988 1.988 0 0027 28.006c-.05-3.532-.32-7.31-1.993-8.997z",
    fill: props.color
  }));
}

export default SvgIconMenuAccountOutline;